import { PayoutResultsApiConfig, PayoutResultsMoreApiConfig } from '../types'

const authorizedFetch = async (
  url: URL,
  getBearerToken: () => Promise<string>,
  signal?: AbortSignal
): Promise<Response> => {
  let token = ''
  try {
    token = await getBearerToken()
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Unknown error'
    console.warn('Failed to retrieve bearer token:', message)
  }

  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    signal,
  })
}

export const payoutResultsApi = {
  query: async (config: PayoutResultsApiConfig): Promise<Response> => {
    const url = new URL(`${config.baseUrl}/payout-results/query-logs`)
    url.searchParams.set('companyId', config.companyId)
    url.searchParams.set('startDate', config.startDate)
    url.searchParams.set('endDate', config.endDate)

    return authorizedFetch(url, config.getBearerToken, config.signal)
  },

  fetchMore: async (config: PayoutResultsMoreApiConfig): Promise<Response> => {
    const url = new URL(`${config.baseUrl}/payout-results/query-logs`)
    url.searchParams.set('queryId', config.queryId)
    if (config.nextToken) {
      url.searchParams.set('nextToken', config.nextToken)
    }

    return authorizedFetch(url, config.getBearerToken, config.signal)
  },
}
